import React, { useMemo } from 'react';
import { FilterSideMenu } from '@/modules/shared/FilterSideMenu';
import { useAssetsSelector } from './useAssetSelector';
import { MaintenanceTable } from '@/modules/shared/Maintenance/MaintenanceTable';
import { generateTestId } from '@/utils/shared/generateTestIds';

interface AssetsMaintenanceProps {
  assets: any;
}

export const AssetsMaintenance = ({ assets }: AssetsMaintenanceProps) => {
  const { items, defaultVal, handleFilterUpdate } = useAssetsSelector({
    assets,
  });

  const data = useAssetsSelector({
    assets,
  });

  const itemsWithTestIds = useMemo(() => items.map((item) => ({
    ...item,
    menuItems: item.menuItems.map((menuItem) => ({
      ...menuItem,
      test_id: generateTestId(`card_${menuItem.asset_ui_name}`)
    }))
  })), [items])

  return (
    <div className="h-[calc(100vh-11.5rem)] flex gap-4 relative">
      <div className="w-1/5 min-h-full">
        <FilterSideMenu
          items={itemsWithTestIds}
          defaultSelected={defaultVal}
          variant={'maintenance'}
          onFilterChange={handleFilterUpdate}
          title={<div>Assets</div>}
        />
      </div>
      <div className="w-4/5 min-h-full">
        <MaintenanceTable enableEditing={false} />
      </div>
    </div>
  );
};
